import React, { PureComponent } from 'react';
import { I, webRoot } from '../../../common/v5/config';
import {
	TextInputRow,
	TextField,
	CustomInputRow
} from '../../../reactcomponents/Form';
import {
	LabelToggleSwitch as ToggleSwitch
} from '../../../components/v5/ToggleSwitch';
import { INPUT_EMPTY_WARNING, FORM_SUBMIT_EMPTY_WARNING } from "../../../common/v5/constants"
import update from 'immutability-helper';
import { UnnestedAreaSingleSelect } from '../../../reactcomponents/Dropdown';
import { TXT_NO_SELECTION } from '../../../common/v5/receiptGreetingConstants';


const helperForName = I("This is the name that will be displayed in the list of accounts. This name is only used to help you identify the account.")

const helperForArea = I("An area must be chosen because the App Store account needs to be connected with an area.")

const helperForEnable = I("If the account is enabled the system will fetch reviews from your App Store app.") + "<br/>" + I("If it is not enabled the system will not do anything with the account.")

const helperForIssuerID = I("The Issuer ID from App Store Connect. Find this in Users and Access > Keys.")

const helperForKeyID = I("The Key ID of your API key from App Store Connect.")

const helperForPrivateKey = I("The private key (.p8 file contents) downloaded from App Store Connect when you created the API key.")

const helperForBundleID = I("The Bundle Identifier of your iOS app (e.g., com.example.myapp).")

const helperForAppID = I("The numeric App ID from App Store Connect. Find this in App Information.")

const helperForAppName = I("The display name of your app (optional, for reference only).")


const helperForConnectionTest = I("Test your App Store Connect API credentials before saving.")

export default class AccountAppStoreForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			id: 0,
			name: "",
			connectedArea: "",
			reqInputs: {
				name: {touched:false},
				issuerID: {touched:false},
				keyID: {touched:false},
				bundleID: {touched:false},
				appID: {touched:false},
			},
			isTestingConnection: false,
			connectionTestResult: null
		};
	}

	componentDidMount = () => {
		let ds = this.props.input;
		if(typeof ds.id !== 'undefined' && ds.id > 0){
			this.setState({
				id: ds.id,
				name: ds.name,
				connectedArea: ds.connectedArea,
			});
		}
	}

	handleSelectArea = (val) => {
		this.props.onChangeAdminInput("selectedArea", val, this.props.view);
	}

	handleToggle = (value, field) => {
		this.props.onChangeAdminInput(field, value)
	}

	handleFieldWarning = (e) => {
		let field = e.target.name;
		let reqInputs = this.state.reqInputs;
		if (reqInputs[field]) {
			reqInputs = update(reqInputs,{
				[field]: {
					touched:{$set: true}
				},
			})
			this.setState({reqInputs:reqInputs})
		}
	}

	handleTestConnection = () => {
		const { input } = this.props;
		const { issuerID, keyID, privateKey } = input;

		if (!issuerID || !keyID || !privateKey) {
			alert(I("Please fill in Issuer ID, Key ID, and Private Key before testing connection."));
			return;
		}

		this.setState({ isTestingConnection: true, connectionTestResult: null });

		$.post(webRoot + 'appstore/testconnection', {
			issuerID: issuerID,
			keyID: keyID,
			privateKeyPath: privateKey
		})
		.done((response) => {
			this.setState({
				isTestingConnection: false,
				connectionTestResult: {
					success: response.success,
					message: response.message
				}
			});
		})
		.fail((xhr) => {
			let message = I("Connection test failed");
			if (xhr.responseJSON && xhr.responseJSON.error) {
				message = xhr.responseJSON.error;
			}
			this.setState({
				isTestingConnection: false,
				connectionTestResult: {
					success: false,
					message: message
				}
			});
		});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let reqInputs = this.state.reqInputs;
		let input = this.props.input;
		let valid = true;
		if (input.selectedArea === "0") {
			return alert(I("Please select area"));
		}
		$.each(reqInputs, (field, v)=>{
			reqInputs = update(reqInputs,{
				[field]: {
					touched:{$set: true}
				},
			})
			if(input[field] === "" || input[field] === undefined) {
				// For existing accounts, privateKey can be empty (to keep existing key)
				if (field === "privateKey" && this.props.activeId > 0) {
					// skip validation for privateKey on edit
				} else {
					valid = false;
				}
			}
		});
		this.setState({reqInputs:reqInputs})
		if(valid){
			this.props.onSave();
		} else {
			alert(FORM_SUBMIT_EMPTY_WARNING);
		}
	}

	render() {
		const {
			areaList
			, activeId
			, input
			, onHandleTextInputChange
			, hidden
			, baseButtons
			, isNew
		} = this.props;

		let selectedArea = parseInt(input.selectedArea, 10);
		const st = this.state;
		const field = st.reqInputs;
		const warnTxt = INPUT_EMPTY_WARNING;

		return (
			<form onSubmit={this.handleSubmit} className="admin-one-form edit-admin-form" hidden={hidden}>
				<CustomInputRow
					id={"area"}
					name={"area"}
					label={I('Area')}
					className={"admin-dropdown-select"}
					mandatory={true}
					helper={helperForArea}
				>
					<UnnestedAreaSingleSelect
						data={areaList}
						invalidSelectedText={TXT_NO_SELECTION}
						onSelect={this.handleSelectArea}
						selected={selectedArea}
						nested={{key: 'Areas'}}
						idFields={{id: "Id", name: "Name"}}
					/>
				</CustomInputRow>
				<TextInputRow
					id={"name"}
					name={"name"}
					className="admin-text-input"
					label={I("Name")}
					value={input.name || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.name && field.name.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForName}
				/>
				<ToggleSwitch
					id={"enable"}
					name={"enable"}
					data-qa-id="enableAppStore"
					label={I("Activated")}
					checked={input.enable}
					onClick={this.handleToggle}
					listWrap={false}
					className="admin-text-input"
					helperTxt={helperForEnable}
				/>
				<TextInputRow
					id={"issuerID"}
					name={"issuerID"}
					className="admin-text-input"
					label={I("Issuer ID")}
					value={input.issuerID || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.issuerID && field.issuerID.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForIssuerID}
				/>
				<TextInputRow
					id={"keyID"}
					name={"keyID"}
					className="admin-text-input"
					label={I("Key ID")}
					value={input.keyID || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.keyID && field.keyID.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForKeyID}
				/>
				<TextField
					id={"privateKey"}
					name={"privateKey"}
					className="admin-text-input"
					label={I("Private Key")}
					value={input.privateKey || ""}
					onChange={onHandleTextInputChange}
					mandatory={isNew}
					placeholder={!isNew ? I("Leave empty to keep existing key") : ""}
					textArea={true}
					helperTxt={helperForPrivateKey}
				/>
				<TextInputRow
					id={"bundleID"}
					name={"bundleID"}
					className="admin-text-input"
					label={I("Bundle ID")}
					value={input.bundleID || ""}
					placeholder="com.example.myapp"
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.bundleID && field.bundleID.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForBundleID}
				/>
				<TextInputRow
					id={"appID"}
					name={"appID"}
					className="admin-text-input"
					label={I("App ID")}
					value={input.appID || ""}
					placeholder="123456789"
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.appID && field.appID.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForAppID}
				/>
				<TextInputRow
					id={"appName"}
					name={"appName"}
					className="admin-text-input"
					label={I("App Name")}
					value={input.appName || ""}
					onChange={onHandleTextInputChange}
					helperTxt={helperForAppName}
				/>
				<CustomInputRow
					id={"connectionTest"}
					name={"connectionTest"}
					label={I("Connection Test")}
					className={"admin-test-connection"}
					helper={helperForConnectionTest}
				>
					<div className="d-flex align-items-center gap-2">
						<button
							type="button"
							className="btn btn-outline-primary"
							onClick={this.handleTestConnection}
							disabled={st.isTestingConnection}
						>
							{st.isTestingConnection ? I("Testing...") : I("Test Connection")}
						</button>
						{st.connectionTestResult && (
							<div className={`alert ${st.connectionTestResult.success ? 'alert-success' : 'alert-danger'} py-1 px-2 mb-0`}>
								{st.connectionTestResult.message}
							</div>
						)}
					</div>
				</CustomInputRow>
				{baseButtons}
			</form>
		)
	}
}

